<template>
  <div class="content">
    <h1 class="content__title">Lista de Galerías</h1>
    <span class="content__details">Listado de galerías de images, pueden ser utlizadas para Sliders, banners o galerías de imágenes simples.</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Galerías</h2>
          <div class="main__results">
            <div class="result" v-if="galleries === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!galleries">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(gallery, index) in galleries" :key="index">
              <router-link :to="{name: 'galleryImageList'}" class="result__data">
                <h2 class="result__title" v-text="'Nombre: ' + gallery.name"></h2>
                <p class="result__detail" v-text="'Tipo: ' + gallery.type"></p>
                <p class="result__detail" v-text="'Título: ' + gallery.title_es"></p>
              </router-link>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'galleryImageList', params: {gallery_id: gallery.id,page: 1}}">Imágenes</router-link>
                <router-link class="btn btn__default btn--small" :to="{name: 'galleryEdit', params: {id: gallery.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteGallery(gallery.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryNew'}">Nueva Galería</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryTypeList', params: {page: 1}}">Tipos de Galerías</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      confirm: false,
      galleries: 'loading',
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getGalleries()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getGalleries()
    }
  },
  methods: {
    deleteGallery: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'galleries'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getGalleries()
            this.$store.commit('notificate', {
              title: 'GALERÍA BORRADA',
              text: 'La galería ha sido borrada correctamente.',
              type: 'success'
            })
          }
        )
    },
    getGalleries: function () {
      let httpRequest = {
        module: 'galleries',
        params: '?fields=name,title_es,id,type&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination'
      }
      this.get(httpRequest)
        .then(
          galleries => {
            this.galleries = galleries.data
            this.pagination.pages = galleries.pagination.pages
            this.pagination.currentPage = galleries.pagination.current_page
            this.pagination.results = galleries.pagination.results
          }
        )
        .catch(
          () => {
            this.galleries = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'galleryList', params: {page: this.page - 1}})
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
</style>



// WEBPACK FOOTER //
// src/components/galleries/list.vue